import { captureException } from '@sentry/react';
import is from '@sindresorhus/is';
import trackEvent from 'utils/analytics';
import httpApiRequest from 'utils/http-api-request';

type FillArgs = {
  resumeId: string;
  userId: string;
  enrichArgs: {
    name?: string;
    company?: string;
    profile?: string;
  };
};

export async function startResumeMagicFill(args: FillArgs) {
  const { resumeId, enrichArgs } = args;
  try {
    trackEvent.linkedInImportStarted(eventData(args));
    await httpApiRequest('magic-fill/resume', {
      method: 'POST',
      json: { resumeId, enrichArgs },
    });
    trackEvent.linkedInImportSuccess(eventData(args));
  } catch (error) {
    trackEvent.linkedInImportError(eventData(args));
    captureException(error, { tags: { noFeedback: true } });
    // Throw so UI can alert user of error
    throw error;
  }
}

function eventData(args: FillArgs) {
  const { resumeId, userId, enrichArgs } = args;
  const fillType = is.nonEmptyString(enrichArgs.profile)
    ? 'url'
    : 'name-company';
  return {
    resumeId,
    userId,
    fillType,
    URL: enrichArgs.profile,
    name: enrichArgs.name,
    company: enrichArgs.company,
  };
}
